import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CART_CART_KLARNA_POPUP} from 'constants/analytics/events/cart';
import {CHECKOUT_ARBITRARY} from 'constants/analytics/events/checkout';
import {PayOverTimeLocations} from 'constants/payOverTime';

import {PropsType} from './payOverTime';

/**
 * Analytics for PayOverTime
 */
export const sendAnalytics = (location: PropsType['location']) => {
    switch (location) {
        case PayOverTimeLocations.CART:
            sendDesktopAnalyticsEvent(CART_CART_KLARNA_POPUP, {
                action: 'Right Section',
                label: 'Learn More - Pay Over Time',
            });
            break;
        case PayOverTimeLocations.CHECKOUT_REBATE:
            sendDesktopAnalyticsEvent(CHECKOUT_ARBITRARY, {
                action: 'Side Bar',
                label: 'Learn More - Pay Over Time',
            });
            break;
        default:
            break;
    }
};
